import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { ENRICHMENT_STATE } from '@aibees/elephant/types';

export function useCheckRevelationPeoplePhoneState(data?: PeopleTableInfo) {
  return (
    data?.revelation?.phone_cached?.state &&
    data?.revelation?.phone_cached?.state !== ENRICHMENT_STATE.PROCESSING
  );
}
